import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames/bind';
import { GRAPH_API_FRAGMENT_DEFINITION, GRAPH_API_FRAGMENT_REFERENCE, } from '../../utils/symbols';
import WorkflowDetails from './WorkflowDetails';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const ClosingStandardWorkflow = ({ closing, }) => {
    const groups = closing.workflow?.task_groups || [];
    const offerWorkflowStatus = closing.workflow?.current_status_label ?? 'Upcoming';
    return (_jsx("div", { className: cx('milestones-container'), children: groups.map(group => (_jsx(WorkflowDetails, { group: group, offerWorkflowStatus: offerWorkflowStatus, closing: closing }, group.code))) }));
};
const WORKFLOW_FRAGMENT = `
  fragment ReoOfferWorkflowDetails on ReoOffer {
    workflow {
      task_groups {
        code
        label
        description
        tooltip_label
        status
        tasks {
          code
          label
          status
          completed_date
          last_updated_date
        }
      }
      current_status_label
    }
  }
`;
ClosingStandardWorkflow.ReoOfferWorkflowFragment = {
    [GRAPH_API_FRAGMENT_DEFINITION]: WORKFLOW_FRAGMENT,
    [GRAPH_API_FRAGMENT_REFERENCE]: `...ReoOfferWorkflowDetails`,
};
export default ClosingStandardWorkflow;
//# sourceMappingURL=index.js.map